import { IdResource } from "../../constants/IdResource";
import { IdIcon } from "../generic/icon/IdIcon";
export var MapGrowthFundActionButtonIcon = new Map([
    [IdResource.Gold, IdIcon.GoldCoinsDecoIcn],
    [IdResource.Money, IdIcon.FarmDollarShop_1_Icn],
    [IdResource.HumusSeaweed, IdIcon.HumusSeaweedIcn],
    [IdResource.FertilizerSeaweed, IdIcon.HumusSeaweedIcn],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-action-button/mapGrowthFundActionButtonIcon.ts
// module id = 2290
// module chunks = 3